export default "__VITE_ASSET__CbQY_5M4__"